export default __webpack_public_path__ + "assets/f613f540776a18a3106f9b4b99ed3132.svg";